import { Stack, Typography } from '@mui/material';
import { RadioButtons } from 'Components';
import { yesNoOptions } from 'Constants';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { IndexContext } from 'Modules/CaseDetails/CaseContext';
import { useContext } from 'react';
import { useWatch } from 'react-hook-form';
import { InjuriesDetails } from './InjuriesDetails';

export const TreatmentsAndTests = () => {
  const { index } = useContext(IndexContext);

  const dictionary = useDictionary(Dictionary, DICTIONARY.CASE_DETAILS);

  const baseName = `caseDetails.${index}`;

  const [wasMedicalInstitutionTreatment] = useWatch({
    name: [`${baseName}.wasMedicalInstitutionTreatment`],
  });

  return (
    <Stack gap='20px' mt='16px'>
      <Stack gap='10px'>
        <Typography sx={{ fontWeight: 'bold' }}>
          {dictionary.fifthSectionTreatmentsTitle}
        </Typography>
        <Typography>{dictionary.fifthSectionTreatmentsTitleDesc}</Typography>
      </Stack>
      <RadioButtons
        id={dictionary.fifthSectionDidTreatQ}
        name={`${baseName}.wasMedicalInstitutionTreatment` as const}
        options={yesNoOptions}
      />
      {wasMedicalInstitutionTreatment && <InjuriesDetails />}
    </Stack>
  );
};
